import { object } from "prop-types";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { SummaryTableDepths, Tables, hashCode } from "@repo/utils";
import { ELEMENT_TYPES, CELL_WIDTHS } from "@utils";
import { useTableExpandHandler, PinnableCell, Row, RowGroup } from "@tools";
import { HoursCell } from "./cells/HoursCell";
import { RateCell } from "./cells/RateCell";
import { CostCell } from "./cells/CostCell";
import classnames from "classnames";
import { useMemo } from "react";

export const BudgetTrackingSummaryRowGroup = observer(({ workType }) => {
  const { t } = useTranslation();

  const { treePath, name, turnOff } = workType;

  const { handleOpen } = useTableExpandHandler({
    expandable: true,
    isOpened: workType.isOpened,
    onExpand: workType.setOpenState
  });

  const handleTurnOffState = () => {
    workType.setTurnOffState(!turnOff);
  };
  
  const hashedPath = useMemo(() => (
    [Tables.SUMMARY, ...treePath].map((id) => hashCode(id))
  ), [treePath]);

  const tableDepth = SummaryTableDepths.WORK_TYPE;

  return (
    <RowGroup
      tableDepth={tableDepth}
      presetClass="preset-accentSummary"
      isStatic
      hashedPath={hashedPath}
      elementType={ELEMENT_TYPES.WORK}
    >
      {
        <Row
          onExpand={handleOpen}
          expandOnClick
          visible={!turnOff}
          onVisibilityToggle={handleTurnOffState}
          isFirstGroupRow
          isLastGroupRow
          tableDepth={tableDepth}
          noArrow
        >
          <PinnableCell
            minWidth={CELL_WIDTHS.TITLE_BT_SUMMARY}
            pinnedLeft={0}
            allowOverflowDisplay
          >
            <span
              className={classnames(
                "name m-3",
                !name?.length && "semi-transparent"
              )}
            >
              {name || t("common.unnamed")}
            </span>
          </PinnableCell>
          <RateCell workType={workType} />
          <HoursCell workType={workType} />
          <CostCell workType={workType} />
        </Row>
      }
    </RowGroup>
  );
});

BudgetTrackingSummaryRowGroup.propTypes = {
  workType: object.isRequired,
};
